import { render, staticRenderFns } from "./ProjectSummaryCompletedStats.vue?vue&type=template&id=4d5d6a32"
import script from "./ProjectSummaryCompletedStats.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryCompletedStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports